import { withFileUsedParam } from '@wix/media-manager-shared';

export const downloadItem = (url: string) => {
  url = withFileUsedParam(url);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'true';

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};
